<div class="issued-container">
  <div class="issued-topbar">
    <div class="topbar-left">
      <h1>
        Issued Stock
        <small>History of stock issued out of inventory</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Inventory</span> /
        <span class="current">Issued Stock</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input
          type="text"
          placeholder="Filter by item name..."
          [ngModel]="search()"
          (ngModelChange)="search.set($event); onSearchChange()"
        />
      </div>
      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <a class="btn btn-primary" routerLink="/issue-stock">
        <i class="bi bi-box-arrow-up"></i> Issue Stock
      </a>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue"><i class="bi bi-receipt"></i></div>
      <div class="stat-info">
        <div class="stat-label">Total Issues</div>
        <div class="stat-value">{{ stats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green"><i class="bi bi-check-circle"></i></div>
      <div class="stat-info">
        <div class="stat-label">Issued</div>
        <div class="stat-value">{{ stats().issued }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber"><i class="bi bi-box-seam"></i></div>
      <div class="stat-info">
        <div class="stat-label">Qty Issued</div>
        <div class="stat-value">{{ stats().totalQty }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon purple"><i class="bi bi-currency-exchange"></i></div>
      <div class="stat-info">
        <div class="stat-label">Total Value</div>
        <div class="stat-value">{{ formatCurrency(stats().totalValue) }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Branch</label>
        <select [ngModel]="branchFilter()" (ngModelChange)="branchFilter.set($event); onFilterChange()">
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of branches(); track branch.id) {
            <option [value]="branch.id">{{ branch.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredIssues().length }} issues</span>
      <button class="btn btn-outline btn-sm" type="button" (click)="clearFilters()">Clear filters</button>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Issue No.</th>
            <th>Issued To</th>
            <th>Cell</th>
            <th>Destination</th>
            <th>Item</th>
            <th>Branch</th>
            <th>Qty</th>
            <th>Total Value</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (issue of paginatedIssues(); track issue.id) {
            <tr>
              <td><span class="issue-id">{{ issue.issueNumber }}</span></td>
              <td>{{ issue.issuedTo }}</td>
              <td>{{ issue.recipientPhone || '—' }}</td>
              <td>{{ issue.recipientLocation || '—' }}</td>
              <td>{{ issue.itemName || '—' }}</td>
              <td><span class="branch-tag">{{ issue.branch }}</span></td>
              <td>{{ issue.items }}</td>
              <td>{{ formatCurrency(issue.totalValue || 0) }}</td>
              <td>{{ formatDate(issue.issueDate) }}</td>
              <td>
                <span class="status-badge" [class]="issue.status">
                  {{ statusLabel(issue.status) }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  @if (historyItemId(issue); as itemId) {
                    <a class="btn-action track" title="Track this item" [routerLink]="['/item-history', itemId]">
                      <i class="bi bi-geo-alt"></i>
                    </a>
                  }
                  <button type="button" class="btn-action edit" title="Edit issue" (click)="openEditModal(issue)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  @if (issue.status !== 'cancelled' && issue.status !== 'issued') {
                    <button
                      type="button"
                      class="btn-action cancel"
                      title="{{ issue.status === 'reserved' ? 'Release reserved hold' : 'Cancel issue (restores stock if issued)' }}"
                      (click)="quickSetStatus(issue, 'cancelled')"
                    >
                      <i class="bi bi-x-circle"></i>
                    </button>
                  }
                  @if (issue.status === 'pending' || issue.status === 'reserved') {
                    <button
                      type="button"
                      class="btn-action complete"
                      title="{{ issue.status === 'reserved' ? 'Issue reserved stock now' : 'Mark as issued (deducts stock)' }}"
                      (click)="quickSetStatus(issue, 'issued')"
                    >
                      <i class="bi bi-check-circle"></i>
                    </button>
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="11" class="empty-cell">
                No issued stock found. Issue stock from the Issue Stock page.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing {{ paginationStart() }}–{{ paginationEnd() }} of {{ filteredIssues().length }}
    </div>
    <div class="pagination-controls">
      <button class="page-btn" [disabled]="page() <= 1" (click)="goToPage(page() - 1)">
        <i class="bi bi-chevron-left"></i>
      </button>
      @for (n of pageNumbers(); track n) {
        <button class="page-btn" [class.active]="page() === n" (click)="goToPage(n)">{{ n }}</button>
      }
      <button class="page-btn" [disabled]="page() >= totalPages()" (click)="goToPage(page() + 1)">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showEditModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal">
    <div class="modal-header">
      <h2><i class="bi bi-pencil"></i> Edit Issued Stock</h2>
      <button class="close-btn" (click)="closeEditModal()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">
        @if (editingIssue()?.status === 'issued') {
          This stock has been issued. Status cannot be changed.
        } @else {
          Changing status updates the database.
          Marking Pending as Issued deducts stock.
        }
      </p>
      <div class="form-row">
        <div class="form-group">
          <label>Issue No.</label>
          <input type="text" [value]="editingIssue()?.issueNumber || ''" readonly />
        </div>
        <div class="form-group">
          <label>Item</label>
          <input type="text" [value]="editingIssue()?.itemName || '—'" readonly />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Issued To <span class="required">*</span></label>
          <input type="text" [ngModel]="editIssuedTo()" (ngModelChange)="editIssuedTo.set($event)" />
        </div>
        <div class="form-group">
          <label>Issue Date <span class="required">*</span></label>
          <input type="date" [ngModel]="editIssueDate()" (ngModelChange)="editIssueDate.set($event)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Status <span class="required">*</span></label>
          <select
            [ngModel]="editStatus()"
            (ngModelChange)="editStatus.set($event)"
            [disabled]="editingIssue()?.status === 'issued'"
          >
            <option value="pending">Pending</option>
            <option value="reserved">Reserved</option>
            <option value="issued">Issued (Completed)</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
        <div class="form-group">
          <label>Branch</label>
          <input type="text" [value]="editingIssue()?.branch || ''" readonly />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" [disabled]="saving()" (click)="saveIssue()">
        <i class="bi bi-check-lg"></i> {{ saving() ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>
  </div>
</div>

<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-content">
      <div class="toast-title">
        {{ toastType() === 'error' ? 'Error' : toastType() === 'info' ? 'Notice' : 'Success!' }}
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
  </div>
</div>
